import Vue from 'vue'
import App from './App.vue'

// 3rd party imports
import vueDebounce from 'vue-debounce'
import BootstrapVue from 'bootstrap-vue'
import VueCookies from 'vue-cookies'
import vSelect from 'vue-select'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import VueFullPage from 'vue-fullpage.js'
import VueI18n from 'vue-i18n';
import {Validator} from 'vee-validate';
import VueCurrencyFilter from 'vue-currency-filter';
import VeeValidate from 'vee-validate';
import {library} from '@fortawesome/fontawesome-svg-core'
import {faUserSecret, faPlus} from '@fortawesome/pro-light-svg-icons'
import _ from 'lodash';
import PageTracker from "@shared/_services/tracker";
import VueQrcodeReader from "vue-qrcode-reader";
import {$settings} from "@shared/settings";
import UtilMixin from "@shared/_mixin/UtilMixin";
import "@fontsource/roboto";
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/100.css"
import "@fontsource/roboto/400.css"

import "@fontsource/muli/latin-300.css"
import "@fontsource/muli/latin-200.css"
import "@fontsource/muli/latin-400.css"
import "@fontsource/muli/latin-500.css"
import "@fontsource/muli/latin-600.css"
import Vue2Editor from "vue2-editor";


library.add(faUserSecret, faPlus);
Vue.use(Vue2Editor);
Vue.use(VueQrcodeReader);
Vue.use(VueI18n);
Vue.use(require('vue-moment'));
Vue.use(vueDebounce);
Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(CKEditor);
Vue.use(VueFullPage);
Vue.use(VueCurrencyFilter);

// easy lodash access
Object.defineProperty(Vue.prototype, '$_', {value: _});
Vue.config.productionTip = false;

// local imports
import router from './router'
import {store} from './src/_store';
import ContentAPI from "@shared/_api/cms/content";

// local components
import BodyBase from './src/viewsShop/components/layout/BodyBase'
import Body from './src/viewsShop/components/layout/Body'
import Spinner from './src/viewsShop/components/ui/Spinner'
import LoadingButton from "./src/components/LoadingButton";
import CustomSelect from "./src/viewsShop/components/ui/CustomSelect";
import Card from "./src/viewsShop/components/Card";
import Carousel from "./src/viewsShop/carousel/Carousel";
import CarouselItem from "./src/viewsShop/carousel/CarouselItem";

Vue.component('pb-spinner', Spinner);
Vue.component('pb-carousel', Carousel);
Vue.component('pb-carousel-item', CarouselItem);
Vue.component('pb-card', Card);
Vue.component('pb-btn', LoadingButton);
Vue.component('pb-body-base', BodyBase);
Vue.component('pb-select', CustomSelect);
Vue.component('pb-body', Body);
Vue.component('pb-callout', Callout);

// external components
Vue.component("v-select", vSelect);


Vue.mixin(UtilMixin);

const paramNames = ['minfirst', 'maxfirst', 'minsecond'];

Validator.extend('betweenAndMin', (value, {minfirst, maxfirst, minsecond} = {}) => {
    return (Number(minfirst) <= value && Number(maxfirst) >= value) || (Number(minsecond) <= value);
}, {
    paramNames
});

Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: 'veeFields'
});

Vue.prototype.$currencyFormatting = $settings.currencyFormatting;
Vue.prototype.$toastDanger = $settings.toasts['toastDanger'];
Vue.prototype.$toastSuccess = $settings.toasts['toastSuccess'];
Vue.prototype.$tracker = new PageTracker();

import ClickOutsideDirective from "@shared/_directives/click-outside";
import Messages from "../shared/_services/messages";
import Callout from "./src/viewsShop/components/ui/Callout";

Vue.directive('click-outside', ClickOutsideDirective);

window.Vue = Vue;

// bootstrap application
Promise.all([ContentAPI.fetchListByName("config"), Messages.getMessages()]).then(([config, messages]) => {
    let result = [];

    config.forEach(configItem => {
        result[configItem.key.value] = configItem.value.value;
    });

    Vue.prototype.$config = result;

    return messages;
}).then(messages => {

    window.addEventListener("resize", function() {
        setTimeout(function(){
            store.dispatch('media/updateWindowWidth');
        },200);
    });

    store.dispatch('account/refreshSessionData').then(() => {

        const i18n = new VueI18n({
            locale: process.env.VUE_APP_I18N_LOCALE || 'en',
            fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
            messages: messages
        });

        new Vue({
            i18n,
            router,
            store,
            mode: 'history',
            render: h => h(App)
        }).$mount('#app')

    });
});






